export default require('color');